<template>
  <div>
    <a-card title="溯源码">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 260px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="按溯源码查询" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width: 220px; margin-bottom: 12px;">
          <a-select v-model="searchForm.batch" placeholder="按批次筛选" allowClear style="width: 100%"
            @change="search">
            <a-select-option v-for="b in batches" :key="b.id" :value="b.id">
              {{ b.product_name }} ({{ b.batch_number }})
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
      </a-row>

      <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
        :pagination="pagination" @change="tableChange" :scroll="{ x: 900 }">
        <div slot="is_active" slot-scope="value">
          <a-tag :color="value ? 'green' : 'red'">{{ value ? '启用' : '停用' }}</a-tag>
        </div>
        <div slot="scan_url" slot-scope="value">
          <a :href="value" target="_blank">{{ value }}</a>
        </div>
      </a-table>
    </a-card>
  </div>
</template>

<script>
  import { traceCodeList, traceBatchList } from '@/api/trace'

  export default {
    name: 'TraceCode',
    data() {
      return {
        columns: [
          { title: '序号', dataIndex: 'index', customRender: (v, item, index) => index + 1, width: 60 },
          { title: '溯源码', dataIndex: 'code' },
          { title: '产品名称', dataIndex: 'product_name' },
          { title: '批号', dataIndex: 'batch_number' },
          { title: '扫码次数', dataIndex: 'scan_count', sorter: true },
          { title: '首次扫描', dataIndex: 'first_scan_time' },
          { title: '最近扫描', dataIndex: 'last_scan_time' },
          { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' } },
          { title: '扫码链接', dataIndex: 'scan_url', scopedSlots: { customRender: 'scan_url' } },
        ],
        searchForm: { search: '', batch: undefined, ordering: '-scan_count', page: 1, page_size: 16 },
        pagination: { current: 1, total: 0, pageSize: 16 },
        loading: false,
        items: [],
        batches: [],
      };
    },
    methods: {
      list() {
        this.loading = true;
        traceCodeList(this.searchForm).then(data => {
          this.pagination.total = data.count;
          this.items = data.results;
        }).finally(() => {
          this.loading = false;
        });
      },
      loadBatches() {
        traceBatchList({ page_size: 999 }).then(data => {
          this.batches = data.results;
        });
      },
      search() {
        this.searchForm.page = 1;
        this.pagination.current = 1;
        this.list();
      },
      tableChange(pagination, filters, sorter) {
        this.searchForm.page = pagination.current;
        this.pagination.current = pagination.current;
        this.searchForm.ordering = sorter.field
          ? `${sorter.order == 'descend' ? '-' : ''}${sorter.field}` : undefined;
        this.list();
      },
    },
    mounted() {
      this.list();
      this.loadBatches();
    },
  }
</script>
